import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';

export interface BankAccountItem {
    readonly id: number;
    readonly default: boolean;
    readonly name: string;
    readonly bankName: string;
    readonly swift: string;
    readonly number: string;
    readonly currencyId: number;
    readonly fullName: string;
}

interface BankAccountInternalItem {
    readonly version: string;
    readonly currencyId: number;
    readonly id: number;
    readonly swift: string;
    readonly default: boolean;
    readonly number: string;
    readonly name: string;
    readonly bankName: string;
}

export class BankAccountCollectionQuery extends Query<BankAccountItem[]> { }

export class BankAccountCollectionQueryHandlerBase implements QueryHandler<BankAccountCollectionQuery, BankAccountItem[]> {
    public static Url = TaggedUrl.join('myCompany/bankAccounts', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(_: BankAccountCollectionQuery): Promise<BankAccountItem[]> {
        const { data } = await this.http.get<{ items: BankAccountInternalItem[]; }>(BankAccountCollectionQueryHandlerBase.Url);
        return data.items.map(i => ({
            id: i.id,
            default: i.default,
            name: i.name,
            bankName: i.bankName,
            swift: i.swift,
            number: i.number,
            currencyId: i.currencyId,
            fullName: `${i.name} - ${i.number}`
        }));
    }
}
